import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';
import { TeammateItem } from '@/types/teammates';
import { formatCurrency } from '@/utils/currency';
import { getTeammateRoleDisplayName } from '@/utils/teammates';
import { SVListItemCard } from '../core';

type TeammatesListProps = {
  teammates: TeammateItem[];
};

export default function TeammatesList({ teammates }: TeammatesListProps) {
  const navigate = useNavigate();

  return (
    <>
      {teammates.map(teammate => {
        const {
          uuid,
          status,
          fullName,
          email,
          role,
          companyName,
          totalActiveBankAccounts,
          totalAvailableBalance,
        } = teammate;

        return (
          <SVListItemCard
            onClick={() => navigate(`${ROUTES.TEAMMATES}/${uuid}`)}
            key={uuid}
            header={fullName}
            status={status}
            statusType="standard"
            manageMenuItems={[
              {
                label: 'Edit',
                onClick: () =>
                  navigate(`${ROUTES.TEAMMATES_EDIT_PARAMS}/${uuid}`),
              },
              {
                label: 'Active Bank Accounts',
                onClick: () =>
                  navigate(`${ROUTES.BANK_ACCOUNTS}?teammate_id=${uuid}`),
              },
              {
                label: 'Draft Bank Applications',
                onClick: () =>
                  navigate(
                    `${ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT}?teammate_id=${uuid}`,
                  ),
              },
              {
                label: 'Businesses',
                onClick: () =>
                  navigate(`${ROUTES.BUSINESSES}?teammate_id=${uuid}`),
              },
              {
                label: 'Customers',
                onClick: () =>
                  navigate(`${ROUTES.CUSTOMERS}?teammate_id=${uuid}`),
              },
            ]}
            additionalInfo={[
              {
                label: 'Email',
                text: email,
              },
              {
                label: 'Role',
                text: getTeammateRoleDisplayName(role),
              },
              {
                label: 'Company',
                text: companyName,
              },
              {
                label: 'Active Bank Accounts',
                text: totalActiveBankAccounts.toString(),
              },
              {
                label: 'Available Balance',
                text: totalAvailableBalance
                  ? formatCurrency({ amount: totalAvailableBalance.value })
                  : formatCurrency({ amount: 0 }),
              },
            ]}
          />
        );
      })}
    </>
  );
}
